var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.299 17.049h3.402v-2.923h-3.402zM22.937 33.873h2.127V22.181h-2.127z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.683 36.684c-6.992 6.993-18.373 6.993-25.365 0A17.818 17.818 0 0 1 6.063 24c0-4.791 1.866-9.295 5.255-12.683A17.878 17.878 0 0 1 24 6.072c4.593 0 9.187 1.748 12.683 5.245A17.816 17.816 0 0 1 41.938 24c0 4.79-1.866 9.296-5.255 12.684m1.504-26.87c-7.822-7.822-20.55-7.823-28.373 0A19.932 19.932 0 0 0 3.937 24a19.936 19.936 0 0 0 5.877 14.187c3.912 3.912 9.049 5.867 14.186 5.867 5.137-.001 10.276-1.956 14.187-5.867A19.936 19.936 0 0 0 44.064 24a19.932 19.932 0 0 0-5.877-14.186"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.dd2fa54c80c11b35e1c1ed7a217bf073.svg";
export { ForwardRef as ReactComponent };